import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import Title from './Utlis/Title';
import { HashtagIcon, HeartIcon } from '@heroicons/react/24/solid';
import { ClockIcon } from '@heroicons/react/24/outline';

const Stories = ({ story }) => {
  const { news, title } = story;

  const splideOptions = {
    perPage: 4,
    perMove: 1,
    type: 'loop',
    rewind: true,
    keyboard: 'global',
    gap: '1rem',
    pagination: false,
    padding: '2rem',
    breakpoints: {
      1200: { perPage: 3 },
      991: { perPage: 2.3 },
      768: { perPage: 2 },
      500: { perPage: 1.3 },
      425: { perPage: 1 },
    },
  };

  return (
    <>
      <div className='nike-container mb-11'>
        <Title title={title} />
        <div className='mt-7'>
          <Splide options={splideOptions}>
            {news.map((val, index) => {
              return (
                <SplideSlide key={index} className='mb-0.5'>
                  <div className=' relative grid items-center gap-4 pb-2 rounded-lg shadow shadow-slate-200 ring-1 ring-slate-200'>
                    <div className='flex items-center justify-center'>
                      <img
                        src={val.img}
                        alt={val.title}
                        className='w-full h-auto object-cover shadow-md shadow-slate-200 roundes-tl-lg rounder-tr-lg'
                      />
                    </div>
                    <div className='flex items-center justify-between w-full px-4'>
                      <div className='flex items-center gap-2'>
                        <HeartIcon className='icon-style text-red-500 w-5 h-5' />
                        <span className='text-font-bold text-sm'>
                          {val.like}
                        </span>
                      </div>
                      <div className='flex items-center gap-2'>
                        <ClockIcon className='icon-style text-slate-900 w-5 h-5' />
                        <span className='text-sm font-bold'>{val.time}</span>
                      </div>
                      <div className='flex items-center gap-2'>
                        <HashtagIcon className='icon-style text-sky-500 w-5 h-5' />
                        <span className='text-sm font-bold'>{val.by}</span>
                      </div>
                    </div>
                    <div className='grid items-center justify-items-start px-4'>
                      <h2 className='text-basefont-semibold lg:text-sm'>
                        {val.title}
                      </h2>
                      <p className='text-sm text-justify lg:text-xs'>
                        {val.text}
                      </p>
                    </div>
                    <div className='grid items-center justify-center px-4 w-full'>
                      <a
                        href={val.url}
                        target='_blank'
                        rel='noreferrer'
                        role={'button'}
                        className='button-theme w-full bg-gradient-to-b from-slate-900 to-black shadow-md shadow-black text-center text-slate-100 py-1.5'
                      >
                        {val.btn}
                      </a>
                    </div>
                  </div>
                </SplideSlide>
              );
            })}
          </Splide>
        </div>
      </div>
    </>
  );
};

export default Stories;
